/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * grimoire/v1/api.proto
 * OpenAPI spec version: version not set
 */

/**
 * FrequencyUnit defines the unit for schedule repetition.

 - FREQUENCY_UNIT_UNSPECIFIED: Unspecified frequency unit.
 - FREQUENCY_UNIT_MINUTE: Schedule repeats every N minutes.
 - FREQUENCY_UNIT_HOUR: Schedule repeats every N hours.
 - FREQUENCY_UNIT_DAY: Schedule repeats every N days.
 - FREQUENCY_UNIT_WEEK: Schedule repeats every N weeks.
 - FREQUENCY_UNIT_MONTH: Schedule repeats every N months.
 - FREQUENCY_UNIT_YEAR: Schedule repeats every N years.
 */
export type V1FrequencyUnit =
  (typeof V1FrequencyUnit)[keyof typeof V1FrequencyUnit];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1FrequencyUnit = {
  FREQUENCY_UNIT_UNSPECIFIED: 'FREQUENCY_UNIT_UNSPECIFIED',
  FREQUENCY_UNIT_MINUTE: 'FREQUENCY_UNIT_MINUTE',
  FREQUENCY_UNIT_HOUR: 'FREQUENCY_UNIT_HOUR',
  FREQUENCY_UNIT_DAY: 'FREQUENCY_UNIT_DAY',
  FREQUENCY_UNIT_WEEK: 'FREQUENCY_UNIT_WEEK',
  FREQUENCY_UNIT_MONTH: 'FREQUENCY_UNIT_MONTH',
  FREQUENCY_UNIT_YEAR: 'FREQUENCY_UNIT_YEAR',
} as const;
